import { get, post } from "./requests";

export async function finishChat({ chatId, token }) {
    return await post("chat/finish", { chatId }, token);
}

export async function getChats({token}) {
    return await get("chat/get/agent", token);
}
